var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-popover',{key:_vm.popoverKey,attrs:{"show":_vm.isTargetVisible,"show-close-button":"","placement":"bottom","triggers":"manual","target":_vm.resolvedTarget,"title":_vm.$options.i18n.title,"css-classes":"gl-z-200"},on:{"close-button-clicked":function($event){return _vm.$emit('dismiss')}}},[_vm._v("\n  "+_vm._s(_vm.$options.i18n.body)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }